import { render, staticRenderFns } from "./ownerCertificationRemind.vue?vue&type=template&id=1899d496&scoped=true&"
import script from "./ownerCertificationRemind.vue?vue&type=script&lang=js&"
export * from "./ownerCertificationRemind.vue?vue&type=script&lang=js&"
import style0 from "./ownerCertificationRemind.vue?vue&type=style&index=0&id=1899d496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899d496",
  null
  
)

export default component.exports